export class InvalidCredentialsError extends Error {
    constructor() {
        super(`Couldn't log in using provided credentials`);

        Object.setPrototypeOf(this, InvalidCredentialsError.prototype);
    }
}

export class EmptyCredentialsError extends Error {
    constructor() {
        super(`Couldn't log in using empty credentials`);

        Object.setPrototypeOf(this, EmptyCredentialsError.prototype);
    }
}

export class InvalidEmailProvided extends Error {
    constructor() {
        super(`The email is incorrect.`);

        Object.setPrototypeOf(this, InvalidEmailProvided.prototype);
    }
}

export class InvalidPlatformError extends Error {
    constructor() {
        super(`The provided platform id is different to active platform.`);

        Object.setPrototypeOf(this, InvalidPlatformError.prototype);
    }
}

export class PasswordMismatchError extends Error {
    constructor() {
        super(`Given passwords do not match.`);

        Object.setPrototypeOf(this, PasswordMismatchError.prototype);
    }
}

export class EmptyPasswordError extends Error {
    constructor() {
        super(`Passwords are empty.`);

        Object.setPrototypeOf(this, EmptyPasswordError.prototype);
    }
}

export class ValidationPasswordError extends Error {
    constructor() {
        super(`Your password does not meet the criteria.`);

        Object.setPrototypeOf(this, ValidationPasswordError.prototype);
    }
}

export class EmptyJwtTokenError extends Error {
    constructor() {
        super(`JWT token is empty.`);

        Object.setPrototypeOf(this, EmptyJwtTokenError.prototype);
    }
}

export class LoginSessionLoadError extends Error {
    constructor() {
        super(LoginSessionLoadError.message);
        Object.setPrototypeOf(this, LoginSessionLoadError.prototype);
    }

    static get message() {
        return `Couldn't load a session from local storage: it's undefined.`;
    }
}

export class InvalidTokenParamError extends Error {
    constructor() {
        super(`Token parameter is invalid.`);

        Object.setPrototypeOf(this, EmptyJwtTokenError.prototype);
    }
}

export class EntityNotFoundEndpointError extends Error {
    constructor() {
        super(`Endpoint error entity not found.`);

        Object.setPrototypeOf(this, EntityNotFoundEndpointError.prototype);
    }
}

export class TooManyLoginAttemptsError extends Error {
    constructor() {
        super(`Too many login attempts.`);

        Object.setPrototypeOf(this, TooManyLoginAttemptsError.prototype);
    }
}
